<template>
  <div class="tiexi">
    <div class="tiexi-box1">
      <!-- <p class="tiexi-num">贴息补贴机具数量<span>{{ this.njTotal }}</span></p> -->
      <p class="tiexi-num">贴息补贴机具总数<span>{{ this.njTotal }}</span>台，已上报农机数<span>{{ this.sendNjNum }}</span>台，未上报农机数<span>{{ this.noSendNjNum }}</span>台</p>
      <div class="maps">
        <div id="mapMain"></div>
      </div>
    </div>
    <div class="tiexi-box2">
      <p class="titles">贴息补贴机具统计</p>
      <p class="item_tab">
        <span :class="[{active: activeName == item.name}]" v-for="(item, index) in itemList" :key="index" @click="tabClick(item)">{{item.name}}</span>
      </p>
      <div id="tiexiEcharts"></div>
    </div>
  </div>
</template>
<script>
import Http from "../../Serves/net-http.js";
import Api from "../../Serves/net-api.js";
import { mapState, mapActions, mapMutations } from "vuex";
import "maptalks/dist/maptalks.css";
import * as maptalks from "maptalks";
import { HeatLayer } from "maptalks.heatmap";
import TalksMap from "../../map/js/initMapTalks.js";
import DiscountDetailsDialog from "../MachineryDistribution/DiscountDetailsDialog";
import TrackLayer from "../MachineryDistribution/mapTrackLayer.vue";
export default {
  components: {
    DiscountDetailsDialog,
    TrackLayer
  },
  data() {
    return {
      tiexiEcharts: '',
      itemList: [
        {
          id: 1,
          name: '机具数量'
        },
        {
          id: 2,
          name: '补贴金额'
        }
      ],
      activeName: '机具数量',
      areaArr: [],
      imeiNumArr: [],
      maxNjNumArr: [],
      maxNumAreaArr: [],
      TalksMap: new TalksMap(),
      popVisible: false,
      markPointData: [],
      markPoint: [],
      isShowBigSmall: false,
      statusStatic: true,
      calendarFlag: false,
      startContinue: "start",
      operationForPauseAndContinue: "pause",
      map: "",
      imei: "",
      njId: "",
      njType: '',
      collectTime: "",
      currentDate: "",
      dialogMapDetail: false,
      zoomEnd: "",
      types: 1,
      njTotal: 0,
      sendNjNum: 0,
      noSendNjNum: 0
    }
  },
  computed: {
    ...mapState({
      handleName: state => state.kName
    })
  },
  watch: {
    handleName(newVal, oldVal) {
      if (newVal == "end") {
        this.operationForPauseAndContinue = "start";
        document.getElementById("pauseBtns").innerHTML = "开始";
        this.continueOrStopUrl = this.kaishi;
        this.calendarFlag = true;
        this.popVisible = false;
      }
    }
  },
  created() {
    let _this = this;
    window.viewHistory = _this.viewHistory;
    window.viewCurrentLine = _this.viewCurrentLine;
  },
  mounted() {
    setTimeout(() => {
      this.homePageNumAndArea()
    }, 500)
    this.$nextTick(() => {
      this.initMapTalk();
    })
    var this_ = this
    document.addEventListener("click", function(e) {
      if (this_.popVisible === true) {
        this_.popVisible = false;
      }
    });
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this_.tiexiEcharts.resize()
      })
    })
  },
  beforeDestroy() {
    //清除当前页定时器
    if (this.requestTimer) {
      clearInterval(this.requestTimer);
      this.timer = null;
    }
  },
  methods: {
    tabClick (item) {
      this.activeName = item.name
      this.types = item.id
      this.homePageNumAndArea()
    },
    homePageNumAndArea (){
      var url=Http.test+'/discountSubsidy/discountNjNumAndSubsidyMoney'
      Api.doPost(url,{
        year: '',
        type: this.types
      },false,(res)=>{
        this.imeiNumArr = res.result.resultList.map(item => {
          return item.typeName
        })
        this.areaArr = res.result.resultList.map(item => {
          return item.countValue
        })
        this.getDataEchart()
      })
    },
    getDataEchart () {
      this.tiexiEcharts=this.$echarts.init(document.getElementById('tiexiEcharts'))
      this.tiexiEcharts.setOption({
        grid: {
          top: '0%',
          left: '5%',
          // top: '25%',
          right: '5%',
          bottom: '1%',
          containLabel: true
        },
        tooltip: {
          show: false,
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
          // formatter: function(params){
          //   console.log(params)
          //   for (var i in params) {
          //     return "<div><p>耕地作业: " + params[i].value +"亩</p></div>"
          //   }
          // },
        },
        xAxis: {
          type: 'value',
          minInterval: 1,
          // boundaryGap: [0, 1],
          splitLine: {
            show: false,
            lineStyle: {
              color: 'rgba(255,255,255,0.3)'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.3)'
            }
          },
          axisLabel: {
            show: true,
            color: '#fff'
          }
        },
        yAxis: [
          { 
            type: 'category',
            data: this.imeiNumArr,
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0.3)'
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#fff',
              // fontSize: 14
            }
          },
          // { 
          //   type: 'category',
          //   position: 'right',
          //   data: this.imeiNumArr,
          //   axisLine: {
          //     show: false,
          //     lineStyle: {
          //       color: 'rgba(255,255,255,0.3)'
          //     }
          //   },
          //   splitLine: {
          //     show: false
          //   },
          //   axisTick: {
          //     show: false
          //   },
          //   axisLabel: {
          //     color: '#fff',
          //     // fontSize: 14
          //   }
          // },
        ],
        series: [//系列列表。每个系列通过 type 决定自己的图表类型
          {
            name: this.activeName === '各地区农机数量' ? '农机数量' : '作业面积',//系列名称
            type: 'bar',//柱状、条形图
            barWidth: 17,//柱条的宽度,默认自适应
            data: this.areaArr,
            label: { //图形上的文本标签
              show: true,
              position: 'right',//标签的位置
              // offset: [-20, 0],
              color: 'black',//标签字体颜色
              textStyle: {
                align: 'center',
                baseline: 'middle',
                // fontSize: 14,
                fontWeight: '400',
                color: '#fff',
                textShadowColor:'#000',
                textShadowBlur:'0',
                textShadowOffsetX:1,
                textShadowOffsetY:1,
              },
            },
            // showBackground: true,
            // backgroundStyle: {
            //   color: '#071892',
            // },
            itemStyle: {//图形样式
              normal: {
                color: '#0b50e8'
              }
            },
            zlevel: 1
          }
        ]
      })
    },
    //初始化地图
    initMapTalk() {
      let this_ = this;
      this.TalksMap.init("mapMain");

      this.allPointLayer = new maptalks.VectorLayer("point").addTo(
        this.TalksMap.map
      );
      this.allHeatLayer = new HeatLayer("heat").addTo(this.TalksMap.map);

      this.$nextTick(() => {
        this.getHeatLayer();
      });

      let noZoomLevel = new maptalks.control.Zoom({
        position: {
          bottom: 10,
          right: 10
        },
        slider: true,
        zoomLevel: true
      });
      this.TalksMap.map.addControl(noZoomLevel);
      this.TalksMap.map.setMinZoom(4);
      this.TalksMap.map.setZoom(4);

      // let Coordinate = {
      //   x: 116.47376166666666,
      //   y: 39.71493666666667
      // };
      // this.TalksMap.map.setCenter(Coordinate);

      //  级别变化事件
      //  级别变化事件
      this.TalksMap.map.on("zoomend", function(e) {
        this_.zoomEnd = e.to;
        if (e.to >= 12) {
          //级别大于12加载地块
          if (this_.allPointLayer.getCount() == 0) {
            let data = this_.TalksMap.map.getExtent();
            this_.getMarkers(data);
          }
        }
        if (e.to < 12 && this_.allHeatLayer.getData().length > 0) {
          //级别小于16删除地块
          this_.allHeatLayer.show();
          this_.allPointLayer.clear();
        }
      });
      //  移动地图事件
      this.TalksMap.map.on("movestart", function(e) {
        this.startPoint = e.containerPoint || e.target.startPoint;
      });
      this.TalksMap.map.on("moveend", function(e) {
        //移动地图结束，计算移动到一定距离加载地块
        this.endPoint = e.containerPoint || e.target.endPoint;
        var a = this.startPoint ? this.endPoint.x - this.startPoint.x : 0;
        var b = this.startPoint ? this.endPoint.y - this.startPoint.y : 0;

        var c = Math.sqrt(a * a + b * b);

        if (c > 300 && this_.zoomEnd >= 12) {
          let data = this_.TalksMap.map.getExtent();
          this_.getMarkers(data);
        }
      });
    },
    //			显示信息窗口
    displayInfoWindow(e) {
      let targetPolygon = e.target;
      let id = targetPolygon.getId();

      targetPolygon.updateSymbol({
        lineColor: "blue"
      });

      console.log(this.list);
      for (var j = 0; j < this.list.length; j++) {
        if (this.list[j].imei === id) {
          //弹窗
          var data = this.list[j];
          this.imei = data.imei;
          this.njType = data.type
          this.njId = data.njId;
          this.dataTitle = data;
          this.collectTime = data.workDate;
          this.dataTitle.operatTime = data.collectTime;
          this.dataTitle.workArea = data.currentLocation;
          var content = [
            '<div id="content">' +
              '<div id="siteNotice" class="mapNotice" style="color: #333;">' +
              "<p>农机类型：" +
              data.njName +
              "</p>" +
              "<p>农机主：" +
              data.ownerName +
              "</p>" +
              "<p>出厂编号：" +
              data.njFactoryCode +
              "</p>" +
              "<p>监控编号：" +
              data.imei +
              "</p>" +
              "<p >采集时间：" +
              data.workDate +
              "</p>" +
              '<p style="width:300px;word-wrap:break-word;word-break:break-all;overflow: auto;height: auto;text-align: left">当前位置：' +
              data.currentLocation +
              "</p>" +
              '<button class="Cancel" onclick="viewCurrentLine()">查看</button>' +
              "</div></div>"
          ];
          var options = {
            single: true,
            width: 383,
            height: 385,
            custom: false,
            dx: 0,
            dy: 0,
            autoPan: false,
            eventsPropagation: true,
            title: "农机信息",
            content: content.join("")
          };
          targetPolygon.setInfoWindow(options);
          targetPolygon.openInfoWindow();
        }
      }

      this.TalksMap.map.panTo(e.coordinate);
    },

    // 查看当天
    viewCurrentLine() {
      console.log(this.dataTitle)
      this.dialogMapDetail = true;
      this.$refs.trackLayer.dataTitle = this.dataTitle;
      this.statusStatic = true;
      this.$refs.trackLayer.trackViewing(); //当天静止状态 (历史)
    },
    // 获取热力图数据
    getHeatLayer() {
      // var url = Http.test + "/screenBuyNj/listGpsLocationForBuyAndMonitorNj";
      var url = Http.test + '/discountSubsidy/discountSubsidyMapDistribution'
      Api.doPost(
        url,
        {
          // year: ''
          // provCode: this.$store.state.info.provCode,
          // countyCode: this.$store.state.info.countyCode,
          // monitorType: 2
        },
        false,
        res => {
          this.markPoint = [];
          this.njTotal = res.result.njTotal
          this.sendNjNum = res.result.sendNjNum
          this.noSendNjNum = res.result.njTotal - res.result.sendNjNum
          this.list = res.result.resultList;
          for (var i in res.result.resultList) {
            this.markPointData.push([
              res.result.resultList[i].lng,
              res.result.resultList[i].lat,
              [i] + 28.9,
              res.result.resultList[i].imei,
              res.result.resultList[i].workType,
              res.result.resultList[i].workState
            ]);
            this.markPoint.push([
              res.result.resultList[i].lng,
              res.result.resultList[i].lat,
              [i] + 28.9
            ]);
          }
          console.log(this.markPointData)
          this.setHeatLayer();
        },
        error => {
          console.log(error);
        }
      );
    },
    setHeatLayer() {
      console.log(this.markPointData)
      this.allHeatLayer.setData(this.markPointData);
      let opt = {
        0.4: "blue",
        0.6: "cyan",
        0.9: "yellow",
        1.0: "red"
      };
      this.allHeatLayer.config({
        radius: 5,
        blur: 6,
        gradient: opt
      });
    },
    //获取markers数据
    getMarkers(data) {
      this.setMarkers();
    },
    setMarkers() {
      let this_ = this;
      this.markPointData.forEach(function(item, index) {
        let imgUrl;
        if (item[5] == 0) {
          imgUrl = require("../../map/img/tuola-hui.png");
        } else {
          imgUrl = require("../../map/img/status.png");
        }

        var point = new maptalks.Marker(item, {
          visible: true,
          editable: true,
          cursor: "pointer",
          shadowBlur: 0,
          shadowColor: "black",
          draggable: false,
          dragShadow: false, // display a shadow during dragging
          drawOnAxis: null, // force dragging stick on a axis, can be: x, y
          symbol: [
            {
              markerFile: imgUrl,
              markerWidth: 30,
              markerHeight: 35,
              markerDx: 0,
              markerDy: 0,
              markerOpacity: 1
            }
          ],
          
        });
        point.setId(item[3]);
        point.setProperties(item[4]);
        point.on("click", this_.displayInfoWindow);
        point.addTo(this_.allPointLayer);
      });
      this.allHeatLayer.hide(); //隐藏热力图
    },
    dialogMapDetailClick() {
      let childLayer = this.$refs.trackLayer;
      let childLayerMap = this.$refs.trackLayer.TalksMapDialog;
      if (childLayerMap._timer || childLayerMap.i > 0) {
        clearInterval(childLayerMap._timer);
        childLayerMap.i = 0;
        childLayerMap._timer = "";
      }
      childLayerMap.lastLineLayer.clear();
      childLayerMap.carPoint.clear();
      childLayerMap.fist = true;
      childLayerMap.lineLog = [];
      childLayerMap.lastLinePoints = [];
      childLayerMap.btnName = "";
      childLayer.operationForPauseAndContinue = "start";
      document.getElementById("pauseBtns").innerHTML = "开始";
      childLayer.continueOrStopUrl = childLayer.kaishi;
      childLayer.calendarFlag = true;

      this.dialogMapDetail = false;

      if (this.requestTimer) {
        clearInterval(this.requestTimer);
        this.timer = null;
      }
    },
    //点击全屏或退出全屏
    bigSmall() {
      if (this.isShowBigSmall) {
        document.exitFullscreen
          ? document.exitFullscreen()
          : document.mozCancelFullScreen
          ? document.mozCancelFullScreen()
          : document.webkitCancelFullScreen
          ? document.webkitCancelFullScreen()
          : document.msExitRequestFullscreen
          ? document.msExitRequestFullscreen()
          : document.msExitFullscreen
          ? document.msExitFullscreen()
          : "";
        document.getElementsByTagName("body")[0].style.overflow = "auto";
      } else {
        var docElm = document.getElementById("mapMain");
        docElm.requestFullscreen
          ? docElm.requestFullscreen()
          : docElm.mozRequestFullScreen
          ? docElm.mozRequestFullScreen()
          : docElm.webkitRequestFullScreen
          ? docElm.webkitRequestFullScreen()
          : docElm.msRequestFullscreen
          ? docElm.msRequestFullscreen()
          : "";
        document.getElementsByTagName("body")[0].style.overflow = "hidden";
      }
      this.isShowBigSmall = !this.isShowBigSmall;
    }
  }
};
</script>
<style scoped>
.tiexi{
  width: 98%;
  height: 87vh;
  margin: 0 auto;
  margin-top: 1vh;
  display: flex;
}
.tiexi-box1 {
  width: 70%;
  background-image: url('/static/img/zuoyejindu-bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  height: 100%;
}
.tiexi-box2 {
  width: 30%;
  background-image: url('/static/img/zuoyejindu-bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  height: 100%;
  margin-left: 1%;
}
.tiexi-num{
  /* width: 100%; */
  text-align: right;
  color: #ffffff;
  line-height: 2;
  font-size: 1vw;
  padding-right: 1vw;
}
.tiexi-num span{
  font-size: 1.3vw;
  padding: 2px 5px;
  background: #0b50e8;
  border-radius: 4px;
  margin-left: 5px;
  margin-right: 5px;
}
#tiexiEcharts{
  width: 100%;
  height: 72vh;
}
.item_tab{
  width: 50%;
  height: 2.5vw;
  margin: 0 auto;
  display: flex;
  margin-bottom: 1vh;
  margin-top: 1vh;
  border-radius: 0.6vw;
  background: #052293;
}
.item_tab span{
  width: 50%;
  display: inline-block;
  text-align: center;
  line-height: 2.5vw;
  color: #ffffff;
  font-size: 1vw;
  cursor: pointer;
}
.item_tab span:nth-child(1){
  border-radius: 0.4vw 0 0 0.4vw;
}
.item_tab span:nth-child(2){
  border-radius: 0 0.4vw 0.4vw 0;
}
.active{
  color: #ffffff;
  font-weight: bold;
  background: #0b50e8;
}
.maps{
  width: 98%;
  margin: 0 auto;
  margin-top: 1vh;
}
#mapMain{
  width: 100%;
  height: 80vh;
}
.titles{
  color: #ffffff;
  font-size: 1.1vw;
  line-height: 2;
  padding-left: 1vw;
}
</style>



// WEBPACK FOOTER //
// src/components/MachineryDistribution/DiscountSubsidy.vue